import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { TopToolbar } from "../layout/TopToolbar";

const filters = [<SearchInput source="q" alwaysOn />];

export const MeetingList = () => (
  <List
    filters={filters}
    actions={
      <TopToolbar>
        <ExportButton />
        <CreateButton label="Nueva reunión" />
      </TopToolbar>
    }
    sort={{ field: "starts_at", order: "DESC" }}
  >
    <DataTable rowClick="edit">
      <DataTable.Col source="title" />
      <DataTable.Col source="meeting_type" />
      <DataTable.Col source="starts_at" field={DateField} />
      <DataTable.Col source="location" />
      <DataTable.Col source="outcome" />
    </DataTable>
  </List>
);
